<div class="trips-container" *transloco="let t">
  <div class="trips-header">
    <h1>{{ t('myTrips') }}</h1>
    <button class="primary-bar-btn create-trip-btn" (click)="createNewTrip()">
      <q-svg-wrapper iconPath="project-icons/add" iconId="a" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
      {{ t('createNewTrip') }}
    </button>
  </div>

  @if (trips.isLoading()) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (trips.error()) {
    <div class="error-container">
      <p class="error-message">{{ t('errorLoadingTrips') }}</p>
    </div>
  }

  @if (trips.value() && trips.value()!.length === 0) {
    <div class="empty-state">
      <p>{{ t('noTripsYet') }}</p>
      <p class="empty-state-hint">{{ t('createFirstTrip') }}</p>
    </div>
  }

  @if (trips.value() && trips.value()!.length > 0) {
    <div class="trips-grid">
      @for (trip of trips.value(); track trip.id) {
        <div class="trip-card">
          <div class="trip-image-container">
            <img [src]="getTripImage(trip)" [alt]="trip.name" class="trip-image">
          </div>

          <div class="trip-content">
            <h3 class="trip-title">{{ trip.name }}</h3>

            @if (trip.description) {
              <p class="trip-description">{{ trip.description }}</p>
            }

            <div class="trip-stats">
              <div class="stat-item">
                <q-svg-wrapper iconPath="project-icons/quest" width="18" height="18" viewBox="0 0 24 24" class="stat-icon"></q-svg-wrapper>
                <span>{{ trip.questsCount || 0 }} {{ t('quests') }}</span>
              </div>
              <div class="stat-item">
                <q-svg-wrapper iconPath="project-icons/planet-20" width="18" height="18" viewBox="0 0 20 20" class="stat-icon"></q-svg-wrapper>
                <span>{{ trip.obelisksCount || 0 }} {{ t('obelisks') }}</span>
              </div>
            </div>
          </div>

          <div class="trip-actions">
            <button mat-icon-button [matMenuTriggerFor]="tripMenu" class="more-actions-btn">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #tripMenu="matMenu">
              <button mat-menu-item (click)="editTrip(trip)">
                <q-svg-wrapper iconPath="project-icons/pencil" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
                <span>{{ t('edit') }}</span>
              </button>
              <button mat-menu-item (click)="viewTrip(trip)">
                <q-svg-wrapper iconPath="project-icons/view-on" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
                <span>{{ t('toView') }}</span>
              </button>
              <button mat-menu-item (click)="openShareModal(trip)">
                <q-svg-wrapper iconPath="project-icons/share" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
                <span>{{ t('share') }}</span>
              </button>
              <button mat-menu-item (click)="openDeleteModal(trip)" class="delete-action">
                <q-svg-wrapper iconPath="project-icons/trash" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
                <span>{{ t('delete') }}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      }
    </div>
  }
</div>

@if (showDeleteModal()) {
  <app-modal
    [title]="'deleteTrip' | transloco"
    [footerButtons]="deleteModalButtons"
    (closeEvent)="showDeleteModal.set(false)">
    <ng-container *transloco="let t">
      <p>{{ t('deleteTripConfirmation', { name: selectedTrip()?.name }) }}</p>
      <p class="warning-text">{{ t('thisActionCannotBeUndone') }}</p>
    </ng-container>
  </app-modal>
}

@if (showShareModal()) {
  <app-modal
    [title]="'shareTrip' | transloco"
    [size]="'medium'"
    [footerButtons]="shareModalButtons"
    (closeEvent)="showShareModal.set(false)">
    <div class="share-content" *transloco="let t">
      <p>{{ t('shareTripDescription') }}</p>

      @if (shareToken()) {
        <div class="share-link-container">
          <input
            type="text"
            readonly
            [value]="getShareUrl()"
            class="share-link-input"
            #shareLinkInput>
          <button class="primary-bar-btn" (click)="copyShareLink()">
            <q-svg-wrapper iconPath="project-icons/clipboard" width="18" height="18" viewBox="0 0 24 24"></q-svg-wrapper>
            {{ t('copy') }}
          </button>
        </div>
      } @else {
        <div class="loading-token">
          <mat-spinner diameter="24"></mat-spinner>
          <span>{{ t('generatingShareLink') }}</span>
        </div>
      }
    </div>
  </app-modal>
}

